import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { GameCodeRegistration } from '@/components/teams/GameCodeRegistration';
import { ScorekeeperGameRequestInterface } from '@/components/venue/ScorekeeperGameRequestInterface';
import { useUserRole } from '@/hooks/useUserRole';

interface GameCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export const GameCodeModal: React.FC<GameCodeModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const { permissions } = useUserRole();
  const isScorekeeper = permissions.role === 'scorekeeper';
  
  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl bg-[#0d1117] border-gray-800">
        <DialogHeader>
          <DialogTitle className="text-white">
            {isScorekeeper ? 'Who Needs a ScoreKeeper?' : 'Join Game with Code'}
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            {isScorekeeper 
              ? 'Find games that need scorekeepers and apply to officiate' 
              : 'Enter a game code to register your team for an upcoming game'
            }
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4">
          {isScorekeeper ? (
            <ScorekeeperGameRequestInterface />
          ) : (
            <GameCodeRegistration onSuccess={handleSuccess} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};